import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { NestedTreeControl } from '@angular/cdk/tree';
import { MomService } from 'src/app/service/mom.service';
import { MatTreeNestedDataSource } from '@angular/material/tree';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { environment, environment_const } from 'src/environments/environment';
import { AgendaTaskEditDialogComponent } from '../agenda-task-edit-dialog/agenda-task-edit-dialog.component';
import { MeetingService } from 'src/app/service/meeting.service';
import { MatDialog } from '@angular/material/dialog';
import { BreakpointObserver, Breakpoints, BreakpointState } from '@angular/cdk/layout';
import { Observable } from 'rxjs';
import { SideNavServiceService } from 'src/app/service/side-nav-service.service';
import { agendaList } from 'src/app/models/basicMeetingModel';

interface TreeNode {
  name: string;
  id?: number;
  selected?: boolean;
  expandable?: boolean;
  children?: TreeNode[];
  level?: number;
  type?:string;
}

/**
 * Checklist database, it can build a tree structured Json object.
 * Each node in Json object represents a to-do item or a category.
 * If a node is a category, it has children items and new items can be added under the category.
 */
@Component({
  selector: 'app-mom-tree',
  templateUrl: './mom-tree.component.html',
  styleUrls: ['./mom-tree.component.css']
})
export class MomTreeComponent implements OnInit, AfterViewInit {
  @Input() MoMData: any;
  @Input() meetingResponse: any;
  @Input() meetingId!: number;
  @Input() isApprovedTree:any=false;
  @ViewChild('momCkEditor') public momCkEditor: any;
  @Output() ckeditorContent = new EventEmitter<any>();
  @Output() isMinuteTask = new EventEmitter<any>();
  @Output() isMinuteNote = new EventEmitter<any>();
  @Output() isMinuteDecision = new EventEmitter<any>();
  @ViewChild('momTree') momTree:any;
  componentName='Mom-Tree'
  ShowMoreIcon=false;
  nodePath: any;
  minutesReqJSON: any;
  result: any[] | undefined;
  TREE_DATA: any;
  showLoading:boolean=false;
  treeControl = new NestedTreeControl<any>(node => node.children);
  taskTreeControl = new NestedTreeControl<any>(node => node.children);
  dataSource = new MatTreeNestedDataSource<TreeNode>();
  isCheckBoxNode : boolean = false;
  flattenedDTOs?: agendaList[] = []; // Flattened array of DTOs
  groupedDTOs?: agendaList[] = []; // Array to store grouped DTOs

  readOnlyQuillConfig: any = {
    letter: false,
    modules: {
      toolbar: false
    },
    placeholder: ' ',
    theme: 'snow',
    readOnly: true
  };

  isExtraSmall: Observable<BreakpointState> = this.breakpointObserver.observe(
    Breakpoints.XSmall
  );
  isMedium: Observable<BreakpointState> = this.breakpointObserver.observe(
    Breakpoints.Medium
  )
  isSmall: Observable<BreakpointState> = this.breakpointObserver.observe(
    Breakpoints.Small
  )

  NumberOfRecords=7;
  position=-1;
  json_format?:JSON;
  expandedNodes?:any;
  firstNodeExpand:boolean=false;
  index!:number;

  initialize(meetingId: number) {
    //if(type=='N'){
    this.index=0;
    this.showLoading=true;
    var meetingIdArr=[];
    if(this.position==-1&&this.meetingResponse!=null && this.meetingResponse.followUpCode!=undefined && this.meetingResponse.followUpCode!=null && this.meetingResponse.followUpCode==environment_const.followupTypeCode){
        meetingIdArr[this.index]=meetingId.toString();
        this.index++;
        this.position=this.meetingResponse.linkedMeetingInfo.length-1;
    }
    if(this.meetingResponse!=null && this.meetingResponse.followUpCode!=undefined && this.meetingResponse.followUpCode!=null && this.meetingResponse.followUpCode==environment_const.followupTypeCode){
      if(this.meetingResponse.linkedMeetingInfo!=null && this.meetingResponse.linkedMeetingInfo!=undefined){
        new Array(this.NumberOfRecords).fill(1).forEach(() => {
          if(this.position>=0){
            meetingIdArr[this.index]=this.meetingResponse.linkedMeetingInfo[this.position].meetingId.toString();
            this.index++;
          this.position--;
        }
      })
      //meetingIdArr=(meetingIdArr.substring(0, meetingIdArr.length - 1));
      }
    }
    else{
     
      meetingIdArr[this.index]=meetingId.toString();
    }
    this.index=0;
     this.fetchingMinutes(meetingIdArr);
  //}

 /* else{
     this.fetchingMinutes(meetingId,type)

  }*/
    
  } 

  recordsPosition?:number;
  fetchingMinutes(meetingId:any){
  //  if(type=='N'){
    var meetingIdArr;
    this.recordsPosition=meetingId.length;
    meetingIdArr=meetingId[this.index];
    this.index++;
    this.minutesReqJSON = { "meetingIdArr": meetingIdArr, "visitorTimeZone": localStorage.getItem('timeszone'), "decryptKey": "" };
   
    if(this.meetingResponse.isConfidential == "Y"){
     
      this.minutesReqJSON.decryptKey = localStorage.getItem("savedpasswords"+"_"+this.meetingResponse.meetingId)
    }
    //this.showLoading=true;
    //invoke minutes service to fetch meeting minutes
   this.momService.fetchTreeviewMinutes(this.minutesReqJSON).subscribe(res => {
    console.log("response data : ",res)
    const jsonString = res.body['minutesData'];
    const jsonData = JSON.parse(jsonString);
    jsonData.forEach((item: any) => {
      this.flattenedDTOs= item.children
    });
      setTimeout(() => {
              this.rebuildHierarchy();
            }, 500)
      if(this.TREE_DATA==undefined||this.TREE_DATA==null)
      this.TREE_DATA=JSON.parse(res.body['minutesData']);
      else
      this.TREE_DATA =this.TREE_DATA.concat(JSON.parse(res.body['minutesData']));
     // this.TREE_DATA=this.json_format;
      
      this.treeControl.dataNodes = this.TREE_DATA;
      this.expandedNodes = new Array<any>();
      this.treeControl.dataNodes.forEach(node => {
          if (node.expandable && this.treeControl.isExpanded(node)) {
              this.expandedNodes.push(node);
          }
      });

      this.expandedNodes.forEach((node:any) => {
        this.treeControl.expand(this.treeControl.dataNodes.find(n => n.id === node.id));
    });
     // this.treeControl.expandAll()
     if(this.firstNodeExpand==false){
     this.treeControl.expandDescendants(this.treeControl.dataNodes[0])
     this.firstNodeExpand=true;
     }
      this.dataSource.data = this.TREE_DATA
     /*Object.keys(this.dataSource.data).forEach((x: any) => {
        this.setParent(this.dataSource.data[x], null);
      });*/
      //this.momTree.treeControl.expandAll();
    }).add(()=>{
      if(this.position!=-1&&this.meetingResponse!=null && this.meetingResponse.followUpCode!=undefined && this.meetingResponse.followUpCode!=null && this.meetingResponse.followUpCode==environment_const.followupTypeCode){
        this.ShowMoreIcon=true;
      }
      else{
        this.ShowMoreIcon=false;
      }
      if(this.index==this.recordsPosition){
      this.showLoading=false;
      }
      else{
        this.fetchingMinutes(meetingId)
      }
    });
  

  /*else{
 
     
    this.minutesReqJSON = { "meetingIdArr": meetingId, "visitorTimeZone": localStorage.getItem('timeszone'), "decryptKey": "" };
   
    if(this.meetingResponse.isConfidential == "Y"){
     
      this.minutesReqJSON.decryptKey = localStorage.getItem("savedpasswords"+"_"+this.meetingResponse.meetingId)
    }
    //this.showLoading=true;
    //invoke minutes service to fetch meeting minutes
   this.momService.fetchTreeviewMinutes(this.minutesReqJSON).subscribe(res => {
             this.taskTreeControl.dataNodes = JSON.parse(res.body['minutesData'])
             this.treeControl.dataNodes = this.TREE_DATA;
             this.treeControl.dataNodes.forEach((node:any,index) => {
         
              if(node.id==this.taskTreeControl.dataNodes[0].id){
                  this.treeControl.dataNodes[index]=this.taskTreeControl.dataNodes[0];
             
              }
              this.dataSource.data=this.TREE_DATA
          });
             
            
   })
     
  }*/



  }
  rebuildHierarchy() {
    // Initialize a map to store DTOs by id for quick lookup
    const dtoMap: { [id: number]: agendaList } = {};
    if(this.flattenedDTOs!=undefined){
    for (let j = 0; j < this.flattenedDTOs.length; j++) {
      let numIndex:number=+this.flattenedDTOs[j].agendaId;
      dtoMap[numIndex] = this.flattenedDTOs[j];
    }
    this.groupedDTOs = this.flattenedDTOs?.filter(dto => !dto.parentAgendaId)

                                        .map(rootDto => this.buildTree(rootDto, dtoMap));
  }

  }

 

  buildTree(dto: agendaList, dtoMap: { [agendaId: number]: agendaList }): agendaList {
    const children = this.flattenedDTOs?.filter(child => child.parentAgendaId === dto.agendaId);
    if (children!=undefined && children.length > 0) {
      dto.subtopics = children.map(child => this.buildTree(child, dtoMap));
    }
    return dto;

  }
  
  constructor(private readonly breakpointObserver: BreakpointObserver,public sideNav:SideNavServiceService,private momService: MomService,private meetingService: MeetingService,private matDialog : MatDialog) { 
    this.firstNodeExpand=false;
  }

  ngOnInit(): void {
    this.meetingId = this.meetingId;
    this.initialize(this.meetingId);
  }

  hasChild = (_: number, node: TreeNode) => !!node.children && node.children.length > 0;
  getLevel = (node: TreeNode) => node.level;
  isExpandable = (node: TreeNode) => node.expandable;
  hasNoContent = (_: number, _nodeData: TreeNode) => _nodeData.name === '';

  setParent(data: any, parent: any) {
    data.parent = parent;
    if (data.children) {
      data.children.forEach((x: number) => {
        this.setParent(x, data);
      });
    }
  }

  checkAllParents(checked:any, node: any) {
    //this.taskCheckValue(checked,node); 
    if (node.parent) {
      const descendants = this.treeControl.getDescendants(node.parent);
      node.parent.selected = descendants.every(child => child.selected);
      node.parent.indeterminate = descendants.some(child => child.selected);
      this.checkAllParents(checked, node.parent);
    }
  }
 

  ngAfterViewInit() {
    //this.momTree.treeControl.expandAll();
  }

  ngDoCheck(){
    this.isCheckBoxNode = false;
  }


  checking(icon: any) {
 
  }

  triggerEvent(i: any) {
 
  }
  logNode(node: any[]) {
    // node.isCheckBoxNode = this.isCheckBoxNode;
    if(!this.isApprovedTree){
      console.log(node);
      this.ckeditorContent.emit(node);
    }
    
  }
  checkBoxNode(isCheckBox: boolean){
    if(isCheckBox){
      this.isCheckBoxNode = true;
    }
  }

  trimHtmltoText(node:any){
    var text="";
    if(node.type!=undefined && node.type!=null && (node.type==environment.noteEntityType ||  node.type==environment.decisionEntityType || node.type==environment.taskEntityType)){
      if(node.actualText!=undefined){
        var tempTxt = $("<p>").append(node.actualText);
        if($(tempTxt).html()!=null && $(tempTxt).html()!="" && $(tempTxt).html()!=undefined){
          text=$($(tempTxt).html()).text().trim().replace(/\t/g, '').replace(/\n/g, '');
        }
      }
    }else{
      text=node.name;
    }
    
    return text;
  }
  taskCheckValue(event: any, node: any) {
    var taskChckVal = 0;
    var noteChckVal = 0;
    var decisionChckVal = 0;
    if (node.type == "task") {
      
      if (event.checked) {
        taskChckVal = 1;
      }
      this.isMinuteTask.emit(taskChckVal);
    }else if(node.type == "note"){
      
      if (event.checked) {
        noteChckVal = 1;
      }
      this.isMinuteNote.emit(noteChckVal);
    }else if(node.type=="decision"){
      
      if (event.checked) {
        decisionChckVal = 1;
      }
      this.isMinuteDecision.emit(decisionChckVal);
      
    }
  }

  taskEditDialog(node:any) {
    
    var taskId = node.id;
    this.meetingService.fetchTaskInfo(taskId).subscribe(
      (meetingRes: any) => {
        var matDialogRef = this.matDialog.open(AgendaTaskEditDialogComponent, { data: {taskData :  meetingRes.body,curTaskUiInfo:node}, panelClass: ['animate__animated','animate__slideInLeft'],
        disableClose: true,
        position : {
          left : "0%"
        },
        maxWidth : "100%",
        maxHeight: "100vh",
        width: "50%",
        height : "100vh" });
        const mediumDialogSubscription = this.isMedium.subscribe(size => {
          if(size.matches){
            matDialogRef.updateSize('70vw','100vh');
          }
        })
        const smallSubscription = this.isSmall.subscribe(size => {
          if(size.matches){
            matDialogRef.updateSize('100vw', '100vh');
          }
        })
        const smallDialogSubscription = this.isExtraSmall.subscribe(size => {
          if (size.matches) {
            matDialogRef.updateSize('100vw', '100vh');
          } 
        });
        matDialogRef.afterClosed().subscribe((respValue:any) => {
          
          if(respValue.data=='Y'){
          mediumDialogSubscription.unsubscribe();
          smallSubscription.unsubscribe();
          smallDialogSubscription.unsubscribe();
          this.firstNodeExpand=false;
          this.TREE_DATA=null;
          this.position=-1;
          this.initialize(this.meetingId);
          
          // //
          // respValue = this.minAttrList
          }
        });
      });
   
  }

  transferNode(node:any){
 
    //this.ckeditorContent.emit(node);
  }
}
